import styled from '@emotion/styled'
import * as React from 'react'

import { Section } from '../section'
import { Space } from '../space'

const Inner = styled.div`
  width: 590px;
`

const StyledSingleColumnView = styled.div`
  height: calc(100vh - 184px);
  overflow-y: auto;
`

export const SingleColumnView = ({ children }: { children: React.ReactNode }) => (
  <Section type="quaternary">
    <StyledSingleColumnView>
      <Space isflex alignItems="center" justifyContent="center" pt={6} px={6}>
        <Inner>{children}</Inner>
      </Space>
    </StyledSingleColumnView>
  </Section>
)
